
import {
    defineComponent, reactive, ref
} from 'vue';
import List from '@/components/common/list/src/list.vue';
import { deviceApi } from '@/api';
import { overlayFormData } from '@/util/system';
import { ListActionItem } from '@/components/common/list';
import removeFunc from '@/methods/remove-func';

export default defineComponent({
    components: {
        List
    },
    props: {
        // 设备类型 akuvox设备 和 第三方设备
        type: {
            type: String,
            default: 'intercom'
        },
        // 第三方设备三级菜单标识
        deviceType: {
            type: String,
            default: 'camera'
        }
    },
    setup(props) {
        // 获取build和room框数据
        const updateData = ref(0);
        // 搜索条件
        const formData = reactive({
            Location: '',
            row: 10,
            page: 1
        });
        overlayFormData(formData);

        // 表头   迁移name 改成prop,增加 {
        //     name: 'op',
        //         label: WordList.CaptureListTanleAction
        // }
        const column = [
            {
                name: 'Owner',
                label: WordList.TabelPersonDeviceInHtmlOwner
            }, {
                name: 'Location',
                label: WordList.TabelPersonDeviceInHtmlLocation
            }, {
                name: 'LinkDevice',
                label: WordList.LinkDevice
            }, {
                name: 'CreateTime',
                label: WordList.TabelMessageBoxCreateTime
            }
        ];

        // 表格数据获取
        const tableData = reactive<{row: object[];detail: object[];total: number}>({
            row: [],
            detail: [],
            total: 0
        });

        // 获取第三方设备数据
        const getThirdPartyDeviceApi = () => {
            deviceApi.thirdPartCameraGetListForIns(
                formData,
                (res: {row: object[];detail: object[];total: number}) => {
                    tableData.row = res.row;
                    tableData.detail = res.detail;
                    tableData.total = res.total;
                    updateData.value += 1;
                }
            );
        };
        getThirdPartyDeviceApi();

        // 删除
        const deleteThirdPartyDeviceApi = (data: { UUID: string }) => {
            removeFunc(WordList.TabelDeleteText, () => {
                deviceApi.thirdPartCameraDelete({ UUID: data.UUID }, getThirdPartyDeviceApi);
            });
        };

        // action操作 迁移备注：这部分不用迁移 主要是为了适配删除触发点击
        const action: ListActionItem[] = [{
            type: 'delete2',
            event(data: { UUID: string }) {
                deleteThirdPartyDeviceApi(data);
            },
            class: 'el-icon-delete delete-icon',
            title: WordList.TabelConfigInHtmlDelete
        }];

        return {
            formData,
            column,
            getThirdPartyDeviceApi,
            tableData,
            updateData,
            action
        };
    }
});
